
import { withSvgIcon } from './withSvgIcon';

export const NavBarAnalytics = withSvgIcon(
  <>
    <path d="M4 4.5V19.0001C4 19.5523 4.44772 20.0001 5 20.0001H21" stroke="currentColor" strokeWidth="1.5" />
    <path d="M8.5 16V10" stroke="currentColor" strokeWidth="1.5" />
    <path d="M16.5 16V12" stroke="currentColor" strokeWidth="1.5" />
    <path d="M12.5 16L12.5 7" stroke="currentColor" strokeWidth="1.5" />
  </>,
  { viewBox: '0 0 24 24' },
);
